import { styles as commonStyles } from '../../../assets/common.scss';
import { styles } from './template.scss';

const integrationDetailsPanelTemplate = document.createElement('template');

integrationDetailsPanelTemplate.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <gz-side-menu menuWidth="400" isOpen closeOnClickOutside>
    <div class="wrapper">
      <gz-title id="integration-name"></gz-title>

      <div class="content">
        <gz-labeled-content id="integration-description" class="integration-description" labelFontWeight="500" stacked labelFontSize="12"></gz-labeled-content>
        <gz-labeled-content id="integration-details" class="integration-details">
                   <gz-button type="quiet" buttonHeight="small" color="primary" id="integration-details-button" lowercase></gz-button>
        </gz-labeled-content>
        <gz-labeled-content id="integration-company" class="integration-company">
        </gz-labeled-content>
        <div id="integration-common-data"></div>
        <div id="integration-sensors"></div>
        <div id="integration-sensor-extra-info"></div>
      </div>

      <div id="integration-actions">
       </div>
    </div>
  </gz-side-menu>
`;

export default integrationDetailsPanelTemplate;
